import { useIntl } from 'react-intl'

import { ButtonGroup, FormattedMessage } from '@subaio/components'
import { Form } from '@subaio/components/src/HookForm'

import type {
	Handlers,
	OpportunityCarInsuranceStep,
	OpportunityCarInsuranceStepType,
} from 'containers/OpportunityCarInsurance/handlers'

import { ButtonSolid, ButtonText } from 'components/Buttons'
import { Card } from 'components/Card'
import { Input } from 'components/FormFields'
import { Header } from 'components/Layout'

import { Title } from '../Title'

type Props = TaggedType<OpportunityCarInsuranceStep, OpportunityCarInsuranceStepType.DamageFreeYears> & {
	onShowDrivenDistancePerYear: Handlers['onShowDrivenDistancePerYear']
	onStepBack?: () => void
}

export const DamageFreeYears = ({
	selectedInsurer,
	personalDetails,
	licensePlate,
	onShowDrivenDistancePerYear,
	onStepBack,
}: Props) => {
	const { formatMessage } = useIntl()

	return (
		<Form
			validationMode='all'
			render={(_, { formState }) => (
				<Card>
					<Header>
						<Title>
							<FormattedMessage
								id='opportunityCarInsurance.damageFreeYears.title'
								defaultMessage='How many damage-free years have you accumulated?'
							/>
						</Title>
					</Header>
					<p role='text'>
						<FormattedMessage
							id='opportunityCarInsurance.damageFreeYears.description'
							defaultMessage='You can find this on the most recently issued policy sheet of your current insurance policy.'
						/>
					</p>
					<Input
						name='damageFreeYears'
						type='number'
						maxLength={3}
						validate={(value) => {
							if (value >= 0) return true
							return formatMessage({
								id: 'opportunityCarInsurance.damageFreeYears.negativeDamageFreeYears',
								defaultMessage: 'You cannot compare insurance with negative claim-free years',
							})
						}}
						label={
							<FormattedMessage
								id='opportunityCarInsurance.damageFreeYears.labelDamageFreeYears'
								defaultMessage='Damage-free years'
							/>
						}
					/>
					<ButtonGroup center>
						{onStepBack && (
							<ButtonText
								label={<FormattedMessage id='opportunityCarInsurance.buttonBack' defaultMessage='Back' />}
								onClick={() => onStepBack()}
							/>
						)}
						<ButtonSolid
							label={<FormattedMessage id='opportunityCarInsurance.buttonContinue' defaultMessage='Continue' />}
							disabled={!formState.isValid}
							submit
						/>
					</ButtonGroup>
				</Card>
			)}
			onSubmit={({ damageFreeYears }) =>
				onShowDrivenDistancePerYear(selectedInsurer, personalDetails, licensePlate, damageFreeYears)
			}
		/>
	)
}
